enum USER_URI {
  SIGNUP = '/api/user/signup',
  LOGIN = '/api/user/login',
  LOGOUT = '/api/user/logout',
  DETAILS = '/api/user/details',
  UPDATE = '/api/user/password/update',
  CLEAR = '/api/user/session/clear',
}

enum LLM_URI {
  SEARCH = '/api/llm/chat/generate/rlhf',
  ADDITION_INFO = '/api/parts/image'
}

enum VEHICLE_URI {
  BY_VIN = '/api/vin/decode',
  SEARCH_YMM='/api/ymm/search',
  BY_YMM='/api/ymm/decode'
}

enum RAG {
  CITATIONS = '/api/rag/citations',
}

export const URI = {
  ...USER_URI, ...LLM_URI, ...VEHICLE_URI, ...RAG
}

